import React, { useEffect, useState } from 'react';
import back from '../../assests/images/back_pg.png';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const Privacy = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.pageYOffset > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <div className="header navbar-fixed">
        <nav className={scrolled ? 'scrolled top_nav' : 'top_nav'}>
          <div className="h_left">
            <Link to={-1} className="btn_tp icon_sq">
              <img src={back} alt="back_pg" />
            </Link>
            Privacy Policy
          </div>
        </nav>
      </div>
      <div className="body_area22">
        <div className="cointainr">
          <div className='column_area mrg_top_0'>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">Introduction</h2>
              <p className='head'>
                This policy applies to users who visit or access our GamiflyKash application (“Application”) or uses our services.
                We respect the privacy of its users and are committed to protecting it in all respects. We have drafted this Privacy Policy to explain how we collect, use, store, and share your personal data and our commitment to comply with applicable privacy laws. By using this Application, you accept, without limitation or qualification, these terms outlined in this Privacy Policy and our Terms & Conditions.
              </p>
              <p className='head'>
                The Application may contain links to other companies' websites and services that have privacy policies of their own. We shall not be responsible for the privacy practices of others. This policy applies to all our brands, products, and services. If you do not agree to the terms, please do not use the Application.
              </p>
              <p className='head'>
                You must be 18 years of age or older to utilize the Application. By accessing the content or the Application, you affirm that you are at least 18 years old and possess the legal right to use the Application.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">What you need to do and your confirmation to us?</h2>
              <p className='head'>
                Please read this privacy policy carefully to understand how we handle your personal information. By engaging with us, you confirm that you have read and understood the entirety of this privacy policy, as it applies to you.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">What kinds of information do we collect?</h2>
              <p className='head'>We collect the following categories of information depending on the services you request:</p>
              <p className='desc'>
                <strong>i. Information you provide:</strong> Name, Email ID. Used to manage your account, transactions, and support.
              </p>
              <p className='desc'>
                <strong>ii. Device Information:</strong> We do not collect technical device data.
              </p>
              <p className='desc'>
                <strong>iii. Information from third-party partners:</strong> May include activity data, ad interactions.
              </p>
              <p className='desc'>
                <strong>iv. Cookies and Web Beacons:</strong> Used for tracking and feature testing. You can opt-out via browser settings.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">How do we use this information?</h2>
              <ul className='desc'>
                <li>To provide, improve and develop services.</li>
                <li>To personalize experiences and understand user patterns.</li>
                <li>To show and measure relevant ads and services.</li>
                <li>For internal operations and regulatory compliance.</li>
              </ul>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">Legal basis for use of your personal information</h2>
              <ul className='desc'>
                <li>Performance of contractual obligations.</li>
                <li>User consent for ads and marketing.</li>
                <li>Legitimate interests in service optimization and security.</li>
              </ul>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">How is this information shared?</h2>
              <ul className='desc'>
                <li>We do not share your personal information unless stated.</li>
                <li>With affiliates and new owners if needed.</li>
                <li>With third-party services in accordance with their policies.</li>
                <li>With vendors and service providers for support and analytics.</li>
              </ul>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">How long we store your information?</h2>
              <p className='head'>
                We retain personal data only as long as needed to fulfill the intended purposes or to comply with applicable laws.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">Data Subject Rights</h2>
              <p className='head'>
                You can request deletion, correction, access or export of your personal data at any time.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">Children’s Privacy</h2>
              <p className='head'>
                We do not knowingly collect data from children under 18. If such data is found, it will be deleted promptly.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">Security of your information</h2>
              <p className='head'>
                We employ reasonable security measures to protect your data. However, internet transmissions are not fully secure.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">Intellectual Property Rights</h2>
              <p className='head'>
                All content is protected by copyright and may not be copied, transmitted, or exploited without permission.
              </p>
            </div>
            <div className="earnings dark_bg left_algn">
              <h2 className="main_ttl clr_aqua">How will we notify you of changes?</h2>
              <p className='head'>
                Changes will be posted here. Significant changes will be communicated prior to their implementation.
              </p>
            </div>
            <div className="earnings dark_bg left_algn marginBottom">
              <h2 className="main_ttl clr_aqua">Comments and Questions</h2>
              <p className='head'>
                For questions, contact us at hello@mchamp.com. Last revised on: 24-06-2025
              </p>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Privacy;
